import React, { useState } from "react";
import RepeatTwoToneIcon from "@mui/icons-material/RepeatTwoTone";
import { MakeNormalPost } from "../posts/MakeNormalPost";

interface QuotePostProps {
  postId: number;
}
export const QuotePost: React.FC<QuotePostProps> = ({ postId }) => {
  const [showShare, setShowShare] = useState(false);
  const [makePostModal, setMakePostModalIsOpen] = useState<boolean>(false);

  const handleClick = () => {
    setMakePostModalIsOpen(true);
  };
  return (
    <>
      <div
        className="flex items-center gap-0.5 cursor-pointer"
        onMouseEnter={() => setShowShare(true)}
        onMouseLeave={() => setShowShare(false)}
        onClick={handleClick}
      >
        <RepeatTwoToneIcon />
        <span className={showShare ? "inline" : "hidden"}>Quote</span>
      </div>
      {makePostModal && (
        <MakeNormalPost
          isOpen={makePostModal}
          setIsOpen={setMakePostModalIsOpen}
          postId={postId}
        />
      )}
    </>
  );
};
